import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import { EGender, EPartsLower, TFIOSuggestions } from '../../types/fio';
import { EFioErrorMessages, FIO_SUGGEST_URI } from './constants';
import { getRequestHeaders, getFioRequestBody } from './utils';

export function getFioSuggest(
  query: string,
  part: EPartsLower,
  gender: EGender,
): TThunkAction<Promise<TFIOSuggestions>> {
  return async (dispatch, getState, context) => {
    const { httpApi, config, logger } = context;
    const defaultData: TFIOSuggestions = {
      suggestions: [],
    };

    const token = config.get<string>('e2e.DadataApiKey');

    if (!token) {
      logger.error(EFioErrorMessages.InvalidToken);

      return defaultData;
    }

    try {
      const response = await httpApi.httpRequest({
        method: 'POST',
        uri: FIO_SUGGEST_URI,
        withCredentials: false,
        headers: getRequestHeaders({ token }),
        body: getFioRequestBody({ query, part, gender }),
      });

      if (response.responseStatusCode === 200) {
        return JSON.parse(response.responseBody) as TFIOSuggestions;
      }

      throw new HttpBadStatusCodeError(EFioErrorMessages.InvalidResponse, response.responseStatusCode);
    } catch (e) {
      /** Само по себе запрос за саджестом фио - не критичен, поэтому логируем warning **/
      if (e instanceof HttpBadStatusCodeError) {
        logger.warning(e.message);
      } else {
        logger.warning(EFioErrorMessages.ErrorRequest, e);
      }

      return defaultData;
    }
  };
}
